import { ArrowRight } from "lucide-react";

export default function NextActionsPanel({ actions = [], onSelect, compact = false }) {
  if (!actions.length) return null;
  return (
    <div className={`rounded-xl border border-dashed border-[var(--primary)] bg-[color-mix(in_srgb,var(--primary)_6%,var(--bg-surface))] ${compact ? "p-2.5" : "p-3"} space-y-2`} data-testid="next-actions">
      <p className="text-[11px] font-medium text-[var(--text-primary)]">What you may still want to do</p>
      <div className="space-y-2">
        {actions.slice(0, 6).map((action) => (
          <button
            key={action.id || action.title}
            type="button"
            className="w-full text-left rounded-lg border border-[var(--border-default)] bg-[var(--bg-surface)] px-3 py-2 hover:border-[var(--primary)] transition-colors"
            onClick={() => onSelect?.(action.prompt || action.title)}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="text-xs font-medium text-[var(--text-primary)]">{action.title}</div>
                <div className="text-[10px] text-[var(--text-tertiary)] mt-0.5 leading-snug">{action.body}</div>
              </div>
              <ArrowRight size={12} className="shrink-0 mt-1 text-[var(--primary)]" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
